import React from 'react';
import { BsGear, BsMic } from 'react-icons/bs';
import { IoIosArrowBack } from 'react-icons/io';
import { Link } from 'react-router-dom';

const Header = () => (
  <div>
    <header className="bg--dark-blue-90  w-100 ph3 pv3 pv4-ns ph4-m ph5-l">
      <nav className="f6 fw6">
        <Link
          className="link dim white dib mr6"
          to={{
            pathname: '/Home',
          }}
        >
          {' '}
          <IoIosArrowBack />
          {' '}
        </Link>
        <span className="link dim white dib mr4" href="#" title="year">Coranavirus Tracker</span>
        <span className="link dim white dib mr3" href="#" title="mic">
          {' '}
          <BsMic />
          {' '}
        </span>
        <span className="link dim white dib mr10" href="#" title="parameters">
          {' '}
          <BsGear />
          {' '}
        </span>
      </nav>
    </header>
  </div>
);

export default Header;
